import Minze, { Attrs, EventListeners, MinzeElement, Reactive } from "minze";

export interface TjSelect {
  selectOptions: string;
  selectOptionLabels: string;
}

export class TjSelect extends MinzeElement {
  reactive: Reactive = [["value", "", true]];

  attrs: Attrs = [
    "placeholder",
    ["height", "40px"],
    "type",
    "name",
    "id",
    ["default-value", ""],
    "label",
    ["padding", "7px 14px"],
    ["fontSize", "16px"],
    ["selectOptions", []],
    ["selectOptionLabels", []],
    ["border", "1px solid #AAA"],
    ["error", false],
  ];

  static observedAttributes = [
    "placeholder",
    "options",
    "height",
    "type",
    "name",
    "id",
    "label",
    "default-value",
    "padding",
    "selectOptions",
    "selectOptionLabels",
    "error"
  ];

  onAttributeChange = (name: string, oldValue: string, newValue: string) => {
    if (name === "default-value" && oldValue !== newValue) {
      this.value = newValue ?? "";

      const currentElement = this.select(`#${this.id}`);
      if (currentElement as any) {
        (currentElement as any).value = newValue;
      }
    }

    this.heightValue = this.height ? this.height : "40px";
  };

  changeSelect = (event: Event) => {
    const currentValue = this.value;
    const value = (event as any).target.value
    this.value = (event as any).target.value;
    this.value = value;
    Minze.cast("tj:select-value-change-" + this.name, { value: value });
    if (!currentValue || !value) this.rerender();
  };

  html = () => {
    let showError = typeof this.error === "string" && this.error.length > 0;
    return `
      <div class="select-wrapper">
        ${this.label ? `<label for="${this.id}">${this.label}</label>` : ""}
        <select
          placeholder="${this.placeholder}"
          ${this.type ? `type="${this.type}"` : ""}
          name="${this.name}"
          id="${this.id}"
          class="input ${this.error ? "error" : ""} ${this.value ? "has-value" : ""}"
        >
          ${this.placeholder ? `<option value="" selected disabled></option>` : ""}
          ${
            this.selectOptions &&
            this.selectOptions.length > 0 &&
            this.selectOptions
              .split(",")
              .map(
                (option: any, index) =>
                  `<option value="${option}" ${this.value === option ? "selected" : ""}>${this.selectOptionLabels.split(",")[index]}</option>`
              ).join("")
          }
        </select>
        <tj-select-arrow-icon></tj-select-arrow-icon>
        ${!this.staticPlaceholder ? `<label class="placeholder-label">${this.placeholder || ""}</label>` : ""}
      </div>
      ${showError ? `<tj-error error="${this.error}"></tj-error>` : ""}
    `
  };

  css = () => {
    const paddingValue = this.padding ? this.padding : "7px 14px";
    const borderValue = this.border ? this.border : "1px solid #AAA";
    const fontSizeValue = this.fontSize ? this.fontSize : "16px";
    return `
      :host {
        width: 100%;
      }
      
      .select-wrapper {
        position: relative;
      }
  
      .input:focus-visible {
        outline: unset;
      }
  
      .input {
        width: 100%;
        border: ${borderValue ? borderValue : "unset"};
        ${this.heightValue ? `height: ${this.heightValue};` : ""}
        ${fontSizeValue ? `font-size: ${fontSizeValue};` : ""}
        ${paddingValue ? `padding: ${paddingValue};` : ""}
        background: #fff;
        color: #133762;
        border-radius: 99px;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        border-radius: 8px;
      }
  
      label {
        color:  #1E007D;
        font-size: 16px;
        font-weight: 700;
      }
      
      tj-select-arrow-icon {
        position: absolute;
        top: 0;
        bottom: 0;
        right: 16px;
        display: flex;
        align-items: center;
      }
      
      .error {
        border-color: #DF374B;
      }
      
      .input:focus {
        border-color: #068FC3;
      }
      
      label.placeholder-label {
        margin: 0;
        color: #133762;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        position: absolute;
        pointer-events: none;
        left: 14px;
        top: 8px;
        max-width: calc(100% - 14px * 2);
        white-space: nowrap;
        overflow: hidden;
        transition: 0.2s ease all;
      }
      
      .input:focus ~ label.placeholder-label {
        color: #068FC3;
      }
      
      .input:focus ~ label.placeholder-label, .input.has-value ~ label.placeholder-label {
        top: -8px;
        left: 11px;
        font-size: 11px;
        background: white;
        padding: 0 4px;
        font-style: normal;
        font-weight: 500;
        line-height: 150%;
      }
    `
  };

  handleInput = (event: Event) => {
    this.value = (event as any).target.value;
  };

  eventListeners: EventListeners = [["select", "change", this.changeSelect]];
}
